import React from 'react';
import { FormControl, FormControlLabel, FormGroup, Switch } from '@mui/material';

interface SwitchCancelledEventsProps {
  viewCancelledEvents: boolean;
  onChange: (value: boolean) => void;
}

export const SwitchCancelledEvents: React.FC<SwitchCancelledEventsProps> = ({
  viewCancelledEvents,
  onChange
}) => {
  return (
    <div className="event-grid-header-switch">
      <FormControl component="fieldset">
        <FormGroup aria-label="position" row>
          <FormControlLabel
            control={<Switch color="primary" checked={viewCancelledEvents} />}
            label="View cancelled events"
            labelPlacement="start"
            onChange={(event, value) => onChange(value)}
          />
        </FormGroup>
      </FormControl>
    </div>
  );
}; 